import React from 'react';

import { TasksProvider } from './context/provider';
import { TasksFilters } from './components/filters';
import { TasksList } from './components/list';
import { TasksModal } from './components/modal';
import { TasksNewButton } from './components/new_button';
import { TasksPageCount } from './components/tasks_page_count';
import { TasksPagination } from './components/pagination';
import { TasksQuickFilters } from './components/quick_filters';
import { TasksSortInput } from './components/sort_input';

import type { ReactNode } from 'react';
import type { ForUser } from 'bundles/apex/tasks/types';
import type { MenuOptions } from 'bundles/apex/tasks/types';
import type { Parent } from 'bundles/crm/types';
import type { Props as TaskProps } from './task';
import type { TasksFiltersProps } from './components/filters';
import type { Filters } from './filters/types';

import './styles.scss';

export { useTasks } from './context/tasks_context';
export type { TasksFiltersProps } from './components/filters';

// TODO: Consistent props (hide vs show) would be nice...
export interface Props {
  allowParentSelection?: boolean;
  animateCompletion?: boolean;
  children: ReactNode;
  currentParent?: Parent;
  disableAssignee?: boolean;
  features?: TaskProps['features'];
  filters: TasksFiltersProps;
  forUser: ForUser;
  hideAfterReparenting?: boolean;
  initialFilters?: Partial<Filters>;
  options?: {
    assignees?: [];
    parents?: [];
  };
  paginate?: boolean;
  persistFilters?: boolean;
  paths: {
    attachments: string;
    checkForImmediateReminders: string;
    counts?: string;
    create?: string;
    formDependenciesPath: string;
  };
  showParents?: TaskProps['showParents'];
  showRouterPrompt?: boolean;
  taskMenuOptions?: MenuOptions;
}

function Tasks({
  allowParentSelection,
  animateCompletion,
  children,
  currentParent,
  disableAssignee,
  features,
  filters,
  forUser,
  hideAfterReparenting,
  initialFilters,
  options = {},
  paginate,
  paths,
  persistFilters,
  showParents,
  showRouterPrompt,
  taskMenuOptions,
}: Props) {
  return (
    <TasksProvider
      allowParentSelection={allowParentSelection}
      animateCompletion={animateCompletion}
      currentParent={currentParent}
      disableAssignee={disableAssignee}
      features={features}
      filtersConfig={filters}
      forUser={forUser}
      hideAfterReparenting={hideAfterReparenting}
      initialFilters={initialFilters}
      options={options}
      paginate={paginate}
      paths={paths}
      persistFilters={persistFilters}
      showParents={showParents}
      showRouterPrompt={showRouterPrompt}
      taskMenuOptions={taskMenuOptions}
    >
      {children}
      <TasksModal />
    </TasksProvider>
  );
}

Tasks.Filters = TasksFilters;
Tasks.List = TasksList;
Tasks.NewButton = TasksNewButton;
Tasks.PageCount = TasksPageCount;
Tasks.Pagination = TasksPagination;
Tasks.QuickFilters = TasksQuickFilters;
Tasks.Sort = TasksSortInput;

export default Tasks;
